import { useState, useEffect } from 'react';

const useScrolledHeight = (): number => {
  const [scrolledHeight, setScrolledHeight] = useState(0);

  const handleScroll = () => {
    // Use document.documentElement.scrollTop to handle scroll on the body or html element
    setScrolledHeight(document.documentElement.scrollTop || document.body.scrollTop);
  };

  useEffect(() => {
    // Attach the event listener to the document
    window.addEventListener('scroll', handleScroll);

    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  return scrolledHeight;
};

export default useScrolledHeight;